import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DiscountForm, DiscountFormValues } from "./DiscountForm/DiscountForm";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { useToaster } from "utils";
import { BundleRequirementModeValue, DiscountModel, discountsApi } from "api/payment-discounts";
import { RESOUCE_TYPES_OPTIONS } from "./consts";

const bundleRequirementModeToInt = (m: string | undefined): number => {
  switch (m) {
    case "courseGroupList":
      return BundleRequirementModeValue.CourseGroupList;
    case "categoryMinCount":
      return BundleRequirementModeValue.CategoryMinCount;
    case "courseList":
    default:
      return BundleRequirementModeValue.CourseList;
  }
};

export const DiscountAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: DiscountFormValues) => {
    try {
      const {
        resourceId,
        resourceType,
        categoryIds,
        mode,
        bundleRequirementMode,
        requiredCourseIds,
        benefitCourseIds,
        requiredCourseGroupIds,
        benefitCourseGroupIds,
        bundleCategoryId,
        bundleMinCount,
        autoApply,
        ...rest
      } = data;

      const request: DiscountModel = {
        ...rest,
        mode: mode || "standard",
        courseId: undefined,
        courseGroupId: undefined,
        categoryIds: undefined,
        requiredCourseIds: undefined,
        benefitCourseIds: undefined,
        requiredCourseGroupIds: undefined,
        benefitCourseGroupIds: undefined,
        bundleCategoryId: undefined,
        bundleMinCount: undefined,
        autoApply: undefined,
      };

      if (mode === "standard" || !mode) {
        if (resourceType === "course") {
          request.courseId = resourceId;
        }
        if (resourceType === "course-group") {
          request.courseGroupId = resourceId;
        }
        if (resourceType === "category") {
          request.categoryIds = categoryIds;
        }
        await discountsApi.create(request);
        showSuccess("Kod rabatowy został dodany");
      } else if (mode === "bundle") {
        const requirementModeInt = bundleRequirementModeToInt(bundleRequirementMode);
        const bundlePayload: DiscountModel = {
          ...request,
          applyAutomatically: !!autoApply,
          applyRetroactively: false,
          requirementMode: requirementModeInt,
          requiredCourseIds:
            requirementModeInt === BundleRequirementModeValue.CourseList ? requiredCourseIds : [],
          benefitCourseIds:
            requirementModeInt === BundleRequirementModeValue.CourseList ? benefitCourseIds : [],
          requiredCourseGroupIds:
            requirementModeInt === BundleRequirementModeValue.CourseGroupList
              ? requiredCourseGroupIds
              : [],
          benefitCourseGroupIds:
            requirementModeInt === BundleRequirementModeValue.CourseGroupList
              ? benefitCourseGroupIds
              : [],
          bundleCategoryId:
            requirementModeInt === BundleRequirementModeValue.CategoryMinCount
              ? bundleCategoryId
              : null,
          bundleMinCount:
            requirementModeInt === BundleRequirementModeValue.CategoryMinCount ? bundleMinCount : null,
        };
        await discountsApi.createBundle(bundlePayload);
        showSuccess("Rabat pakietowy został dodany");
      }

      navigate(routes.DISCOUNTS);
    } catch (error) {
      console.error(error);
      showError("Nie udało się dodać kodu rabatowego");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kody rabatowe", path: routes.DISCOUNTS },
          { title: "Tworzenie nowego kodu rabatowego" },
        ]}
        headerText="Dodaj nowy kod rabatowy"
      />

      <DiscountForm onSubmit={onSubmit} resourceTypeOptions={RESOUCE_TYPES_OPTIONS} />
    </PageMain>
  );
};
